module.exports = __webpack_public_path__ + "fonts/font.8399ea3b.woff2";